import { render } from "./Weblog.vue?vue&type=template&id=6e0c5448"
import script from "./Weblog.vue?vue&type=script&lang=js"
export * from "./Weblog.vue?vue&type=script&lang=js"
script.render = render

export default script